import React, { useEffect, useState } from "react"
import styles from "./Thanks.module.css"
import { getAreaPrefecture } from "./getAreaPrefecture"
import { ThanksProps, RecommendOffer } from "./types"
import RecommendOffers from "./RecommendOffers"
import { fetchRecommendOffers } from "../../app/api/recommendOfferApi"

const Thanks = ({ formState }: ThanksProps) => {
    // レコメンド求人はマウント後に非同期取得(失敗時は空=枠非表示)。ページ本体の表示はブロックしない。
    const [recommendOffers, setRecommendOffers] = useState<RecommendOffer[]>([])
    useEffect(() => {
        fetchRecommendOffers().then(setRecommendOffers)
    }, [])

    const [area, setArea] = useState("")
    const [genre, setGenre] = useState(null)
    const [occupation, setOccupation] = useState(null)
    useEffect(() => {
        const getArea = getAreaPrefecture(formState.prefecture)
        const userResumes = formState.userResumesAttributes[0]
        setGenre(userResumes.genreId)
        setOccupation(userResumes.occupationIds)
        setArea(getArea)
    }, [formState])
    return (
        <div className={styles.background}>
            <div className={styles.sparklingLeft}>
                <img
                    src="/foodslaboEf/img/ProgressBanner/decoration-left.png"
                    alt="decoration-left"
                />
            </div>
            <div className={styles.sparklingRight}>
                <img
                    src="/foodslaboEf/img/ProgressBanner/decoration-right.png"
                    alt="decoration-left"
                />
            </div>
            <div className={styles.thanks}>
                <div>
                    <p className={styles.thanksText}>
                        \ ご登録ありがとうございます！ /
                    </p>
                    <div>
                        <img
                            src={`/client/img/thanks/foodslabo/new_member/tel-${area}-pc.png`}
                            alt={"各拠点電話番号"}
                            className={styles.telPc}
                        />
                        <img
                            src={`/client/img/thanks/foodslabo/new_member/tel-${area}-sp.png`}
                            alt={"各拠点電話番号"}
                            className={styles.telSp}
                        />
                    </div>
                </div>
                {/* 「他の求人を見る」は求人一覧へ。UTMで「レコメンド経由(一覧)」を計測 */}
                <RecommendOffers
                    offers={recommendOffers}
                    moreOffersHref="/offers?utm_source=thanksPF&utm_medium=social&utm_campaign=memberPF&utm_content=register-recommended-offer-list"
                />
                {!formState.isKuzenLinked && (
                    <div
                        className={styles.kuzenBanner}
                        data-view-label="Thanks_CT_LINE-連携"
                    >
                        <a
                            href={`${window.location.protocol}//${window.location.host}/redirect?redirect-url=${encodeURIComponent(`liff.line.me/2007824586-AmeOdXEP?sl=16a5613000&encoded_email=${formState.encodedEmail}`)}`}
                            data-click-label="Thanks_CT_LINE-連携_CTAボタン"
                        >
                            <img
                                src="/client/img/thanks/foodslabo/kuzen-foodslabo-thanks-banner-pc.png"
                                alt="Kuzen banner"
                                className={styles.kuzenBannerPc}
                            />
                            <img
                                src="/client/img/thanks/foodslabo/kuzen-foodslabo-thanks-banner-sp.png"
                                alt="Kuzen banner"
                                className={styles.kuzenBannerSp}
                            />
                        </a>
                    </div>
                )}
                <div>
                    <a href="/mypage/resumes/new">
                        <img
                            src="/foodslaboEf/img/Thanks/merit-banner.png"
                            alt="メリット画像"
                            className={styles.merit}
                        />
                    </a>
                </div>
                <div>
                    <img
                        src="/foodslaboEf/img/Thanks/explanation.png"
                        alt="活用法画像"
                        className={styles.explanation}
                    />
                </div>
                <div className={styles.ctaButtonWrap}>
                    <button className={styles.ctaButton}>
                        <a
                            href={`/offers/search/genres-${genre}/occupations-${occupation}`}
                        >
                            求人を探して、さらに応募
                            <span>
                                <img
                                    src={"/foodslaboEf/img/Thanks/arrow.svg"}
                                    alt={"arrow"}
                                />
                            </span>
                        </a>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Thanks
